/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Title = styled.div`
  color: #707070;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const Rol = styled.div`
  color: #707070;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

const Layout = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 24px 16px 24px;
  background: #ebebeb;
  margin-bottom: 16px;
`;

export const RolIs = () => {
  const { roles, is_legal_agent } = useSelector((state) => state.login.loguedAs);

  const rolText = is_legal_agent
    ? 'Representante Legal'
    : roles[0] === 'ADMIN'
    ? 'Superadmin'
    : roles[0] === 'ADMIN-SECONDARY'
    ? 'Admin'
    : roles[0] === 'SELLER'
    ? 'Vendedor'
    : roles[0] === 'ADMIN-ONUS'
    ? 'Admin'
    : roles[0] === 'SUPER-ADMIN-ONUS'
    ? 'Superadmin'
    : roles[0] === 'ANALISTA-ONUS'
    ? 'Analista'
    : roles[0] === 'ADMIN-GA'
    ? 'Admin'
    : roles[0] === 'ADMIN-SECONDARY-GA'
    ? 'Admin secundary'
    : roles[0] === 'SELLER-GA'
    ? 'Vendedor'
    : 'Rol Desconocido';

  const { t } = useTranslation();

  return (
    <Layout>
      <Title>{t('headerDropdown.rol')}</Title>
      <Rol>{rolText}</Rol>
    </Layout>
  );
};

export default RolIs;
